import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";
import Views from "./views";
import { Route, Switch } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from "./configs/AppConfig";
import AuthProvider from "services/Auth";
import AutoSyncOnReconnect from "services/autoSync/AutoSyncOnReconnect";
import "react-update-popup/dist/index.css";
// import "antd/dist/antd.css";
// import "/css/antd.css";

const themes = {
  dark: `/css/dark-theme.css`,
  light: `/css/light-theme.css`,
};

const getNetworkConnection = () => {
  return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
};

const getMinimumInternetState = () => {
  if (!navigator.onLine) {
    return "offline";
  }

  const connection = getNetworkConnection();
  if (!connection || !connection.effectiveType) {
    return "online";
  }

  if (connection.effectiveType === "slow-2g" || connection.effectiveType === "2g") {
    return "minimum";
  }

  return "online";
};

function App() {
  const [minimumInternetState, setMinimumInternetState] = useState(getMinimumInternetState());

  useEffect(() => {
    const handleNetworkStateChange = () => {
      setMinimumInternetState(getMinimumInternetState());
    };

    window.addEventListener("online", handleNetworkStateChange);
    window.addEventListener("offline", handleNetworkStateChange);

    const connection = getNetworkConnection();
    if (connection) {
      connection.addEventListener("change", handleNetworkStateChange);
    }

    return () => {
      window.removeEventListener("online", handleNetworkStateChange);
      window.removeEventListener("offline", handleNetworkStateChange);

      if (connection) {
        connection.removeEventListener("change", handleNetworkStateChange);
      }
    };
  }, []);

  return (
    <>
      <div className={`App ${minimumInternetState !== "online" ? "app-offline" : "app-online"}`.trim()} style={{ overscrollBehavior: "none" }}>
        <AuthProvider>
          <AutoSyncOnReconnect />
          <Provider store={store}>
            <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
              <Router>
                <Switch>
                  <Route path="/" component={Views} />
                </Switch>
              </Router>
            </ThemeSwitcherProvider>
          </Provider>
        </AuthProvider>

        {/* <UpdateNotification title="Nova versão disponível" description="Atualiza a página para usares a última versão." buttonText="Atualizar página" /> */}
      </div>
    </>
  );
}

export default App;
